import type { FC } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import type { UpsellBlock, UpsellLandingPage } from 'generated/resources/datatable.graphql'

import { GlpButtonBlock } from 'modules/discover/components/LandingPageBlocks/GlpButtonBlock'

type UpsellGlpRow = NonNullable<UpsellBlock['glpRow']>

interface GlpRowBlockProps {
  block: UpsellGlpRow
  slug: string
  landingPage: UpsellLandingPage
  currentUpsellOrigin: {
    request_source: string
    request_source_category?: string
    request_source_component?: string
  } | null
}

const MediaBox = ({ src }: { src: string | null | undefined }) => {
  const isVideo = src?.match(/\.(mp4|webm|ogg|mov|avi)$/i)

  return (
    <Box borderRadius={{ all: 'abs016' }} overflowX="hidden" className="w-full md:w-1/2">
      {isVideo ? (
        <video
          src={src || ''}
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '280px',
            display: 'block',
            borderRadius: '14px',
          }}
          autoPlay
          muted
          loop
        />
      ) : (
        <img
          src={src || ''}
          alt=""
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '280px',
            display: 'block',
            borderRadius: '14px',
          }}
        />
      )}
    </Box>
  )
}

const TextBox = ({
  block,
  slug,
  landingPage,
  currentUpsellOrigin,
}: Pick<GlpRowBlockProps, 'block' | 'slug' | 'landingPage' | 'currentUpsellOrigin'>) => (
  <Box
    gap="s16"
    className="w-full md:w-[30%] px-6"
    alignItems="flexStart"
    padding="s40"
    maxWidth="s600"
  >
    {block.rowTitle && (
      <Text size="400" weight="semibold" color="black">
        {block.rowTitle || ''}
      </Text>
    )}
    {block.rowContent && <Text size="300">{block.rowContent || ''}</Text>}
    {block.actions &&
      block.actions.map((action) => (
        <GlpButtonBlock
          key={action?.id}
          block={action}
          slug={slug}
          landingPage={landingPage}
          currentUpsellOrigin={currentUpsellOrigin}
        />
      ))}
  </Box>
)

export const GlpRowBlock: FC<GlpRowBlockProps> = ({
  block,
  slug,
  landingPage,
  currentUpsellOrigin,
}) => {
  if (!block) {
    return null
  }

  const positionIsRight = block?.mediaPosition === 'true'
  return (
    <Box flexDirection="row" gap="s16">
      {positionIsRight ? (
        <>
          <MediaBox src={block?.rowMedia?.url ?? null} />
          <TextBox
            block={block}
            slug={slug}
            landingPage={landingPage}
            currentUpsellOrigin={currentUpsellOrigin}
          />
        </>
      ) : (
        <>
          <TextBox
            block={block}
            slug={slug}
            landingPage={landingPage}
            currentUpsellOrigin={currentUpsellOrigin}
          />
          <MediaBox src={block?.rowMedia?.url ?? null} />
        </>
      )}
    </Box>
  )
}
